import * as React from 'react'
import * as LodashFP from 'lodash/fp'

import { Option } from '../interfaces/components/dynamic-form'

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Icon,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@design/pt-ui'

export interface IProps {
  title?: string
  message?: React.JSX.Element | string
  options: Option[]
  open: boolean
  onConfirm: (option: string) => any
  onClose: () => any
}
interface IState {
  selectedOption: string
}

function ConfirmationDialogWithOptions(props: IProps) {
  const [state, setState] = React.useState<IState>({
    selectedOption: LodashFP.getOr(null, 'options[0].value', props),
  })

  const handleChangeOption = (event: SelectChangeEvent) => {
    setState({ selectedOption: event.target.value })
  }

  const handleConfirmAction = () => {
    props.onConfirm(state.selectedOption)
  }

  return (
    <div>
      <Dialog
        disableRestoreFocus={true}
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        {props.title && (
          <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
        )}
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexFlow: 'row',
              justifyContent: 'center',
            }}>
            <DialogContentText id="alert-dialog-description" />
            <div style={{ marginTop: 10 }}>{props.message}</div>
          </Box>
          <Select value={state.selectedOption} onChange={handleChangeOption}>
            {props.options.map((option, i) => (
              <MenuItem value={option.value} key={i}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onClose} color="inherit" autoFocus={true}>
            <Icon sx={{ fontSize: 44, color: 'red', mr: 2 }}>cancel</Icon>
            {'Cancel'}
          </Button>

          <Button
            onClick={handleConfirmAction}
            color="inherit"
            autoFocus={true}>
            <Icon sx={{ fontSize: 44, color: '#57ac40', mr: 2 }}>
              check_circle
            </Icon>
            {'Ok'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ConfirmationDialogWithOptions
